module.exports = __webpack_public_path__ + "static/media/password-hide.7f21a74a.svg";